import { type AxiosError } from "axios";

export type FormattedApiError = {
  message: string;
  statusCode: string | number;
  error: AxiosError;
};

const formatAndReturnRejectedError = (
  error: AxiosError,
  message?: string,
  statusCode?: string | number,
): Promise<FormattedApiError> =>
  Promise.reject({
    error,
    message:
      message ||
      (error.response?.statusText !== "" && error.response?.statusText) ||
      error.message,
    statusCode: statusCode || error.response?.status || error.code || "UNKNOWN",
  });

export default formatAndReturnRejectedError;
